import * as m from "../../model/model";

import {
  CoursesResponse,
  ExamsQuery,
  ExamsResponse,
} from "../../api/api-model";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { set } from "firebase/database";

export interface AdminState {
  users: m.FbUser[] | null;
  selectedUser: m.User | null;
  coursesResponse: CoursesResponse | null;
  examsResponse: ExamsResponse | null;
  examsQuery: ExamsQuery;
  selectedExam: m.Exam | null;
  questions: m.Question[] | null;
  sections: m.Section[] | null;
  logs: m.Log[];
}

const initialState: AdminState = {
  users: null,
  selectedUser: null,
  coursesResponse: null,
  examsResponse: null,
  examsQuery: { status: "closed" },
  selectedExam: null,
  questions: null,
  sections: null,
  logs: [],
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setSelectedUser: (
      state,
      action: PayloadAction<AdminState["selectedUser"]>
    ) => {
      state.selectedUser = action.payload;
    },
    setUsers: (state, action: PayloadAction<AdminState["users"]>) => {
      state.users = action.payload;
    },
    setCoursesResponse: (
      state,
      action: PayloadAction<AdminState["coursesResponse"]>
    ) => {
      state.coursesResponse = action.payload;
    },
    setExamsResponse: (
      state,
      action: PayloadAction<AdminState["examsResponse"]>
    ) => {
      state.examsResponse = action.payload;
    },
    setSelectedExam: (
      state,
      action: PayloadAction<AdminState["selectedExam"]>
    ) => {
      state.selectedExam = action.payload;
    },
    setExamsQuery: (state, action: PayloadAction<AdminState["examsQuery"]>) => {
      state.examsQuery = action.payload;
    },
    setLogs: (state, action: PayloadAction<AdminState["logs"]>) => {
      state.logs = action.payload;
    },
    addLogs: (state, action: PayloadAction<AdminState["logs"]>) => {
      state.logs = state.logs.concat(action.payload || []);
    },
    setSections: (state, action: PayloadAction<AdminState["sections"]>) => {
      state.sections = action.payload;
    },
    setQuestions: (state, action: PayloadAction<AdminState["questions"]>) => {
      state.questions = action.payload;
    },
  },
});

export const adminActions = adminSlice.actions;
export default adminSlice.reducer;
